module.exports = __webpack_public_path__ + "img/appBar.8076d12a.png";